module.exports = __webpack_public_path__ + "static/media/03_05_08.c122812a.png";